import { all, takeEvery, put, fork, call, select } from "redux-saga/effects";
import { setMaster, masterContants } from "views/app-views/master/redux";
import { branchContants } from "./Constants";
import { BranchServices } from "services";

export function* getAllBranchSaga() {
  yield takeEvery(
    [masterContants.GET_ALL_MASTER, branchContants.GET_ALL_BRANCH],
    function* ({ payload }) {
      try {
        const getCurrentUser = (state) => state.user;
        const { currentUser } = yield select(getCurrentUser);
        const reqBody = {
          limit: 999999999999,
          offset: 0,
          branchId: currentUser.employee.branchId,
        };
        const { data } = yield call(BranchServices.getAllBranch, reqBody);
        yield put(setMaster({ branchs: [...data.rows] }));
      } catch (error) {
        console.log("getAllBranch ", error);
      }
    },
  );
}

export default function* rootSaga() {
  yield all([fork(getAllBranchSaga)]);
}
